<template>
  <div
  :class="{'delivered': delivered}"
  >
    {{ table[Number(frame)] }}
  </div>
</template>

<script>
export default {
  props: {
    frame: {
      type: Number,
      required: true
    },
    date: {
      type: String,
      required: true
    },
    deliveryTime: {
      type: String,
      required: true
    }
  },
  computed: {
    now () {
      return this.$moment()
    },
    len () {
      let time = ''
      switch (this.deliveryTime) {
        case '1':
          time = 10
          break
        case '2':
          time = 15
          break
        case '3':
          time = 20
          break
        case '4':
          time = 25
          break
        case '5':
          time = 30
          break
        case '6':
          time = 40
          break
        case '7':
          time = 60
          break
      }
      return time
    },
    delivered () {
      const start = this.date + ' ' +
      this.table[Number(this.frame)]
      const endTime = this.$moment(start).add(this.len, 'minutes')
      return this.$moment(this.now).isAfter(endTime)
    }
  },
  data: () => ({
    table: {
      0: '10:00',
      1: '10:30',
      2: '11:00',
      3: '11:30',
      4: '12:00',
      5: '12:30',
      6: '13:00',
      7: '13:30',
      8: '14:30',
      9: '10:00',
      10: '10:30',
      11: '11:00',
      12: '11:30',
      13: '12:00',
      14: '12:30',
      15: '13:00',
      16: '13:30',
      17: '14:30',
      18: '10:00',
      19: '10:30',
      20: '11:00',
      21: '11:30',
      22: '12:00',
      23: '12:30',
      24: '13:00',
      25: '13:30',
      26: '14:30'
    }
  })
}
</script>
<style lang="sass" scoped>
.delivered
  color: #ccc
</style>
